// Module
var code = "<div class=\"basket-loader\"> <div class=\"basket-loader__animation\"> <div class=\"basket-loader__animation-strip\"></div> <div class=\"basket-loader__animation-strip\"></div> <div class=\"basket-loader__animation-strip\"></div> </div> </div>";
// Exports
module.exports = code;